{
    "LoadingLabel": "[Bezig met laden...]",
    "NAME": "ComboBox"
}